import axios from "@axios";

export default {
  save(data) {
    return axios.post("/profissional/atendimento/receituarios/", data);
  },
  getById(id) {
    return axios.get(`/profissional/atendimento/receituarios/${id}`);
  },
  getPatientById(id) {
    return axios.get(`/profissional/atendimento/receituarios/paciente/${id}`);
  },
  getPatientAndSpecialtyById(id) {
    return axios.get(
      `/profissional/atendimento/receituarios/paciente/4352/especialidade/${id}`
    );
  },
};
